import React from "react";
import ListCalendar from "./ListCalendar";
import ConflictList from "./ConflictList";
import { Macros } from "../models/Macros";
import { useAppContext } from "../contexts/AppContext";
import { TListCalendarWrapperProps } from "../types/components/ListCalendarWrapper";

type TConflictListCalendarProps = {
    id: number;
    onInfoOpen: (entryIds: number[], showPanel?: boolean) => void;
} & TListCalendarWrapperProps;

const getRefreshEvents = () => [
    Macros.Event.SELECT_RESERVATION,
    Macros.Event.RESERVATION_MADE_OR_MODIFIED,
    Macros.Event.RESERVATION_RESTORED,
];

const ConflictListCalendar = (props: TConflictListCalendarProps) => {
    const appContext = useAppContext();

    const onSelection = (firstReservation, secondReservation) => {
        appContext.fireEvent(
            `conflictList${props.id}`,
            Macros.Event.SELECT_RESERVATION,
            firstReservation
        );
        props.onInfoOpen([firstReservation.id, secondReservation.id], false);
    };

    return (
        <ListCalendar
            {...props}
            type={"conflictList"}
            refreshEvents={getRefreshEvents()}
            onSelection={onSelection}
        >
            <ConflictList />
        </ListCalendar>
    );
};

export default ConflictListCalendar;
